"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _StorageClassAnalysisDataExport_1 = require("./_StorageClassAnalysisDataExport");
exports._StorageClassAnalysis = {
    type: "structure",
    required: [],
    members: {
        DataExport: {
            shape: _StorageClassAnalysisDataExport_1._StorageClassAnalysisDataExport
        }
    }
};
//# sourceMappingURL=_StorageClassAnalysis.js.map